import { types } from "../types/types";

export const manualDocument = (document) => ({
  type: types.getManualDocument,
  payload: document,
});

export const importManualDocument = (document) => {
  return async (dispatch) => {
    try {
      dispatch(manualDocument(document));
    } catch (error) {
      console.error(error);
    }
  };
};
